import Grid from '@mui/material/Grid';
//import TextCard from './TextCard';
import { useTheme } from "@mui/material";


export default function PanelLinePgx({ marker, source, }) {

  const theme = useTheme();
   
    return (

      theme.palette.mode === "light" ? (
     
      <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}> 
                   
          <Grid size={8}  sx={{pl:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {marker} </Grid> 
          <Grid size={4}  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   {source} </Grid> 
       
      </Grid>    
      
      ) : (

   
        <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}> 
                   
          <Grid size={8}  sx={{pl: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {marker} </Grid> 
          <Grid size={4}  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   {source} </Grid> 
     
    </Grid>    

      )

    );
  }